import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { EstablishmentEventData } from "../types/establishmentEventData.type";

export const useEstablishmentEvent: (id: string) => UseQueryResult<EstablishmentEventData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();
  return useQuery<{data: {data: EstablishmentEventData}}, unknown, EstablishmentEventData>({
    queryKey: ['establishmentFee', id],
    queryFn: () => privateAxios.get(`/billing/events/${id}`),
    enabled: !!id,
    select: (data) => {
      return data?.data?.data
    }
  })
}